// BuyButton.jsx
import React from "react";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import { useArtworkPurchaseFlow } from "../hooks/useArtworkPurchaseFlow";

// (CSRF handled via api.ensureCsrf)

/**
 * Props:
 * - artworkId (number|string)
 * - hostId? (number|string)
 * - className? (string)
 * - disabled? (boolean)
 * - iconOnly? (boolean)
 */
export function BuyButton({ artworkId, hostId, className = "", disabled = false, iconOnly = false }) {
  const { startArtworkPurchaseFlow, loading, modalNodes } = useArtworkPurchaseFlow(artworkId, hostId);

  return (
    <>
      <button
        type="button"
        onClick={() => startArtworkPurchaseFlow(artworkId, hostId)}
        disabled={disabled || loading}
        className={iconOnly ? className : `px-4 py-2 rounded-2xl shadow text-sm font-medium border border-gray-300 hover:shadow-md disabled:opacity-50 ${className}`}
        aria-busy={loading}
        aria-label="Buy artwork"
        title="Buy artwork"
        style={iconOnly ? {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          height: 24,
          width: 24,
          padding: 0,
          border: "none",
          background: "transparent",
          cursor: disabled || loading ? "default" : "pointer",
          color: "#111827",
          opacity: disabled || loading ? 0.5 : 1,
        } : undefined}
      >
        {iconOnly ? <LocalMallOutlinedIcon sx={{ fontSize: 20 }} /> : (loading ? "Processing..." : "Buy")}
      </button>
      {modalNodes}
    </>
  );
}
